import { Component, OnInit, ViewChild } from '@angular/core';
import { EnvioService } from '../services/envio.service';
import { ClienteService } from '../services/cliente.service';
import { ListadoEnvios } from '../models/viewmodels/listadoEnvios';
import { EnvioViewModel } from '../models/viewmodels/envioViewModel';
import { FormControl } from '@angular/forms';
import { DoubleBounceComponent } from '../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../shared/custom-alert/custom-alert.component';
import { Router } from '@angular/router'
import { ClienteViewModel } from '../models/viewmodels/ClienteViewModel';
import { ReenvioComprobanteViewModel } from '../models/viewmodels/ReenvioComprobanteViewModel';

@Component({
  selector: 'app-envios',
  templateUrl: './envios.component.html',
  styleUrls: ['./envios.component.scss']
})
export class EnviosComponent implements OnInit {

  query = new FormControl();
  pagina: number = 0;
  cantidadPorPagina: number = 20;
  listado: ListadoEnvios = null;
  paginas: number = 0;
  isLoading = true;
  envio: EnvioViewModel;
  display: boolean = false;
  mostrarDetalle: boolean = false;

  public tags:Array<ClienteViewModel> = [];
  public clientes:Array<ClienteViewModel> = [];
  
  reenvioComprobantes:ReenvioComprobanteViewModel;
  reenviarTodos:boolean = false;
  mostrarReenvioComp:boolean = false;
  es:any;

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  constructor(private envioService: EnvioService, private router: Router, private clienteService: ClienteService) {
    this.listado = new ListadoEnvios();
    this.reenvioComprobantes = new ReenvioComprobanteViewModel();
    this.reenvioComprobantes.todos = true;
    this.listado.envios = new Array<EnvioViewModel>();
    this.es = {
      firstDayOfWeek: 1,
      dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      dayNamesMin: [ "D","L","M","X","J","V","S" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      today: 'Hoy',
      clear: 'Borrar'
  }
   }

  ngOnInit() {
    this.obtenerEnvios();
    this.query.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe(term => {
        if (term.length == 0) {
          this.pagina = 0;
          this.obtenerEnvios();
        }else if(term.length > 2){
          this.obtenerEnvios();
        }
      });
  }

  obtenerEnvios(paginaActual?: number) {
    this.pagina = paginaActual == null ? 0 : paginaActual;
    this.spinner.isRunning = true;
    this.envioService.listado(this.pagina, this.cantidadPorPagina, this.query.value ? this.query.value : "").subscribe(result => {
      this.spinner.isRunning = false;
      this.listado = result;
      if (this.listado && this.listado.total > 0) {
        this.paginas = Math.floor((this.listado.total + this.cantidadPorPagina - 1) / this.cantidadPorPagina);
      }
    });
  }

  anterior() {
    this.obtenerEnvios(this.pagina - 1);
  }

  siguiente() {
    this.obtenerEnvios(this.pagina + 1);
  }

  buscar() {
    this.pagina = 0;
    this.obtenerEnvios();
  }

  showDialog(envio: EnvioViewModel) {
    this.envio = envio;
    this.display = true;
  }

  eliminar() {
    this.display = false;
    this.spinner.isRunning = true;
    this.envioService.eliminar(this.envio.id).subscribe(result => {
      this.alert.visible = true;
      this.alert.titulo = "Eliminar envio";
      if (result.status == 204) {
        this.alert.tipo = "success"
        this.alert.mensaje = `El envio se ha eliminado correctamente`
      } else {
        this.alert.tipo = "danger"
        this.alert.mensaje = "El envio no se ha podido eliminar. Por favor vuelva a intentarlo."
      }
      this.alertComponent.setType(this.alert.tipo);
      this.listado.envios = this.listado.envios.filter(u => {
        return u.id != this.envio.id
      });
      this.envio = null;
      this.spinner.isRunning = false;
    }, error => {
      this.spinner.isRunning = false;
      this.alert.visible = true;
      this.alert.titulo = "Eliminar envio";
      this.alert.tipo = "danger"
      this.alertComponent.setType(this.alert.tipo);
      this.alert.mensaje = "El envio no se ha podido eliminar. Por favor vuelva a intentarlo."


    })
  }

  reenviar(id:number){
    this.spinner.isRunning = true;
    this.envioService.reenviar(id).subscribe(result => {
      this.alert.visible = true;
      this.alert.titulo = "Reenviar comprobantes";
      if (result.status == 200) {
        this.obtenerEnvios();
        this.alert.tipo = "success"
        this.alert.mensaje = `Los comprobantes seleccionados se ha reenviado correctamente`
      } else {
        this.alert.tipo = "danger"
        this.alert.mensaje = "Los comprobantes seleccionados no se han podido reenviar. Por favor vuelva a intentarlo."
      }
      this.alertComponent.setType(this.alert.tipo);            
      this.spinner.isRunning = false;
    }, error => {
      this.spinner.isRunning = false;
      this.alert.visible = true;
      this.alert.titulo = "Reenviar comprobantes";
      this.alert.tipo = "danger"
      this.alertComponent.setType(this.alert.tipo);
      this.alert.mensaje = "Los comprobantes seleccionados no se han podido reenviar. Por favor vuelva a intentarlo."


    })
  }  

  reenviarComprobantes(){
    this.spinner.isRunning = true;    
    this.envioService.reenviarComprobantes(this.reenvioComprobantes).subscribe(result => {
      this.alert.visible = true;
      this.alert.titulo = "Reenviar comprobantes";
      if (result.status == 201) {
        this.obtenerEnvios();
        this.alert.tipo = "success"
        this.alert.mensaje = `Los comprobantes se ha reenviado correctamente`
        this.mostrarReenvioComp = false;
        this.reenvioComprobantes = new ReenvioComprobanteViewModel();
        this.obtenerEnvios();
      } else {
        this.alert.tipo = "danger"
        this.alert.mensaje = "Los comprobantes no se han podido reenviar. Por favor vuelva a intentarlo."
      }
      this.alertComponent.setType(this.alert.tipo);            
      this.spinner.isRunning = false;
    }, error => {
      this.spinner.isRunning = false;
      this.alert.visible = true;
      this.alert.titulo = "Reenviar comprobantes";
      this.alert.tipo = "danger"
      this.alertComponent.setType(this.alert.tipo);
      this.alert.mensaje = "Los comprobantes no se han podido reenviar. Por favor vuelva a intentarlo."


    })
  }

  verDetalle(envio:EnvioViewModel){
    this.mostrarDetalle = true;
    this.envio = envio;
  }

  estado(id: number) {
    var estado = "";
    switch (id) {
      case 0:
        estado = "Generado";
        break;
      case 1:
        estado = "Enviado";
        break;
      case 2:
        estado = "No Enviado";
        break;
      case 3:
        estado = "Recibido";
        break;
      case 4:
        estado = "Spam";
        break;
      case 5:
        estado = "Abierto";
        break;
      case 6:
        estado = "Rebotado";
        break;
      case 7:
        estado = "Rechazado";
        break;
    }
    return estado;
  }

  paginate(event) {    
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
    this.obtenerEnvios(event.page);
  }


  filtrar(event) {    
    if (event.query.length > 3) {
      return this.clienteService.listado(0, 10, event.query).subscribe(response => {        
        this.clientes = response.clientes;        
      });

    }
  }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/envios/envios.component.ts